import { render } from "./Pedidos.vue?vue&type=template&id=3341d65e"
import script from "./Pedidos.vue?vue&type=script&lang=js"
export * from "./Pedidos.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__